
const ThirdPartyServices = () => {
  const services = [
    {
      name: "YouTube",
      description: "When you watch our educational videos, YouTube may set cookies to remember your viewing preferences and provide related content recommendations."
    },
    {
      name: "Google Analytics",
      description: "We use Google Analytics to understand how our website is used. These cookies collect anonymous information about visitor behavior."
    },
    {
      name: "Social Media Platforms",
      description: "Social media buttons and embedded content may set cookies from platforms like Facebook, Instagram, and other social networks."
    }
  ];

  return (
    <div className="space-y-4">
      {services.map((service, index) => (
        <div key={index} className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-semibold text-gray-900 mb-2">{service.name}</h3>
          <p className="text-gray-700 text-sm">{service.description}</p>
        </div>
      ))}
    </div>
  );
};

export default ThirdPartyServices;
